$(document).ready(function() {
  var $popupOverlay = $("#popup-overlay");
  var $popup = $("#popup-message");
  var $closeButton = $("#close-popup");

  if ($popupOverlay.length && $popup.length && $closeButton.length) {

    $popupOverlay.show();
    $popup.show();

    $closeButton.on("click", function() {
      $popupOverlay.hide();
      $popup.hide();
    });

    $popupOverlay.on("click", function(event) {
      if (!$(event.target).closest("#popup-message").length) {
        $popupOverlay.hide();
        $popup.hide();
      }
    });
  }
});
